// extracted by mini-css-extract-plugin
export default {"main":"Vet_main__9uCWJ","formDiv":"Vet_formDiv__ITUY0","form":"Vet_form__cvoHo","input":"Vet_input__5KHu5","select":"Vet_select__ldKGL"};